// extracted by mini-css-extract-plugin
module.exports = {"componentsWingBlank":"styles_componentsWingBlank__2D6s_"};